export const SET_USER = 'SET_USER';
export const SET_NEWUSER = 'SET_NEWUSER';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_VENDORLOGIN = 'SET_VENDORLOGIN';
export const SET_NEWVENDOR = 'SET_NEWVENDOR';
